import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface tableLoaderState {
  isTableLoaderVisible: boolean;
}

interface ToggleVisibilityPayload {
  isTableLoaderVisible: boolean;
}

export const initialState: tableLoaderState = {
  isTableLoaderVisible: false
};

const tableLoaderSlice = createSlice({
  name: 'tableLoader',
  initialState,
  reducers: {
    toggleTableLoaderVisibility(state, action: PayloadAction<ToggleVisibilityPayload>) {
      state.isTableLoaderVisible = action.payload.isTableLoaderVisible;
    }
  }
});

export const {
  toggleTableLoaderVisibility
} = tableLoaderSlice.actions;

export default tableLoaderSlice.reducer;
